import { useState } from "react";
import { TextField } from "@mui/material";
import { usePlacesWidget } from "react-google-autocomplete";

export default function GoogleAutocomplete(props) {
  const [inputValue, setInputValue] = useState(
    Object.keys(props.place)
      .map((_) => props.place[_])
      .filter((_) => !_).length === 0
      ? `${props.place.formatted_street_address}, ${props.place.city}, ${props.place.state} ${props.place.zip_code}`
      : ""
  );
  const { ref } = usePlacesWidget({
    apiKey: process.env.REACT_APP_GOOGLE_KEY,
    libraries: ["places", "geometry"],
    onPlaceSelected: (place) => {
      const geoLookup = {};
      place.address_components.forEach((g) => {
        g.types.forEach((t) => {
          geoLookup[t] = g;
        });
      });
      const getStreetNumber = () => {
        return (geoLookup["street_number"] || {})["short_name"];
      };
      const getStreetName = () => {
        return (geoLookup["route"] || {})["short_name"];
      };
      const getCity = () => {
        const a = geoLookup["locality"] || {};
        const b = geoLookup["sublocality"] || {};
        const c = geoLookup["sublocality_level_1"] || {};
        return a["long_name"] || b["long_name"] || c["long_name"];
      };
      const getState = () => {
        return (geoLookup["administrative_area_level_1"] || {})["short_name"];
      };
      const getZipCode = () => {
        return (geoLookup["postal_code"] || {})["short_name"];
      };
      const getCounty = () => {
        return (geoLookup["administrative_area_level_2"] || {})["short_name"];
      };
      props.onPlaceSelected({
        formatted_street_address: `${getStreetNumber()} ${getStreetName()}`,
        city: getCity(),
        state: getState(),
        zip_code: getZipCode(),
        county: getCounty(),
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      });
      setInputValue(
        `${getStreetNumber()} ${getStreetName()}, ${getCity()}, ${getState()} ${getZipCode()}`
      );
    },
    options: {
      types: [],
    },
  });

  return (
    <TextField
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      placeholder="Enter a location"
      style={props.style}
      InputProps={{
        style: {
          background: "white",
        },
      }}
      size="small"
      inputRef={ref}
    />
  );
}
